import { useCallback } from 'react';
import { simpleMultilineTextField, useFundIdField } from '../../../data-fields/CommonFields';
import { transactionDateField } from '../../../data-fields/TransactionFields';

export function useMiscWriteOffFields() {
  const fundIdField = useFundIdField();
  return useCallback(() => {
    return [fundIdField, transactionDateField(), simpleMultilineTextField({ key: 'notes', label: 'Notes' })];
  }, [fundIdField]);
}
